// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3UKhj","actions":"GroupTable_actions__8Fk5X","deleteModalFooter":"GroupTable_deleteModalFooter__3SDQa"};